export const wrhLangEs = {
         ticketWrh: {
           storeName: "Nombre de la tienda de conveniencia",
      look: "Mira", //翻译

           selectStore:
             "Por favor, elija el nombre de la tienda de conveniencia",
           waitApproval: "Esperando la validación",
           alApproval: "Validado",
           approvalComments: "Comentarios de validación",
           currentApproval: "Current node processor",
           time: "Tiempo",
           approvalPeople: "Aprobador",
           approvalComment: "Comentario de aprobación",
           waitOrder: "Esperando ser procesado",
           orderstatus: "Estado del pedido",
           loanamount: "Importe del préstamo",
           partiallyCompleted: "Parcialmente completado",
           normalStatus: "Normal",
           noNormalStatus: "Anormal",
           userName: "Nombre de usuario",
           orderInvalidTime: "Tiempo de caducidad del pedido",
           dial: "marcar número",
           Submit: "Completo",
           IsGP0: "non-F2F",
           IsGP1: "F2F",
           showNumber: "Número",
           To: 'a'
         },
         tipsWrh: {
           calcFee: "Calcular la comisión",
           calcFeeTip:
             "Nota: Ingrese el monto del pago de préstamo y haz clic en Calcular la comisión para saber el monto de la comisión y de IVA. ",
           fee: "la comisión",
           feeIVA: "la comisión y de IVA",
           currentPersonalTime: "Veces disponibles para descontar",
           currentGroupTime: "Veces disponibles del equipo",
           currentRemainingDeduction: "El importe total de la reducción actualmente disponible para el resto de personas",
           makeLoan: "Préstamos",
           continueFollow: "Continuar con el seguimiento",
           userBirthday: "Fecha de nacimiento del usuario",
           enterUserBirthday:
             "Por favor, ingrese la fecha de nacimiento del usuario",
           opreSuccess: "Operación exitosa",
           enterMark: "Otras（Notas)",
           userAndOrder: "Información de usuario y pedido",
           diaOperation: "Operación de marcación",
           productInfo: "Información del producto",
           product: "Producto",
           pleaseResult: "Por favor, seleccione el resultado",
           teleMarketRecord: "Registros de ventas telefónicas",
           previewImage:
             "Soy una imagen, haz clic para obtener una vista previa",
           selectBrithday: "Elige tu fecha de nacimiento",
           enterTelephone: "Ingresa el número de tu amigo o amiga",
           enterIdCard: "Ingresa tu ID de INE",
           enterCurp: "Ingresa tu CURP",
           enterStaffNum: "Por favor ingrese ID de empleado",
           enterChilNum: "Ingresa el número de hijos",
           enterFamilyAddress: "Ingresa la dirección de domicilio",
           enterPhone: "Ingresa el número de tu amigo o amiga",
           enterCompanyName: "Ingresa el nombre de empresa",
           enterCompanyPosition: "Ingresa el puesto",
           enterCompanyTime: "Ingresa el tiempo que laboraste",
           enterRewardMoney: "Ingresa el monto",
           editPeople: "Editar la información",
           addPeople: "Nueva información",
           enterRFC: "Por favor ingrese RFC",
           noNormal: "Informal",
           admin: "Admin",
           editBaseInfo: "Editar los datos personales",
           enterStatus: "Elige el estado actual",
           recordTitle: "Registro de entrada y salida",
           clickAdd:
             "Haga clic para añadir la información básica del empleado...",
           workRecord: "Registro de entrada y salida",
           enterChooseTime: "Por favor, elija una hora",
           tip: "Prompt",
           cumulativeReward: "Recompensa acumulada",
           cumulativePunish: "Penalización acumulativa",
           cumulativeLtter: "Recibir una carta de advertencia",
           Times: "Tiempo",
           seal: "Seal",
         },
         menuWrh: {
           reduceApproval: "reduce Approval",
           teleMarket: "Telemarketing",
           teleMarketRecord: "Telephone sales records",
         },
         tableWrh: {
           reduceType: "Tipo del descuento",
           applyPeople: "Solicitante",
           approvalResult: "Estatus de resultado",
           approvalDetail: "Detalles de la aprobación",
           reduceResult: "Reducción de los resultados",
           reduceAmount: "Importe de la exención",
           Operador: "Operator",
           dialTime: "Tiempo de llamada",
           whentherDial: "Ya sea para marcar",
           dialSituation: "Situación de acceso telefónico",
           remark: "Notas",
         },
         formWrh: {
           birthDay: "Fecha de nacimiento",
           cardId: "ID de INE",
           cardCURP: "CURP",
           cardPhoto: "Fotos de tu INE",
           staffNum: "ID de empleado",
           marryStatus: "Estado civil",
           chilNum: "Número de hijos",
           familyAddress: "Dirección de domicilio",
           addressProof: "Comprobante de domicilio",
           familyContact: "Referencias",
           familyRealtion: "Relación",
           familyTelephone: "Número de contacto",
           companyName: "nombre de empresa",
           companyPosition: "Puesto",
           companyTime: "Tiempo que laboraste",
           punishType: "Tipo de reconocimiento o sanción",
           Type: "Tipo",
           punishMoney: "Monto destinado (MXN)",
           questionType: "Tipo de penalización",
           punishDesc: "Descripción",
           //选择项label
           man: "Masculino",
           woman: "Femenino",
           onJob: "En el trabajo",
           quit: "Desempleado",
           married: "Casado,a",
           unmarried: "Divorciado,a",
           single: "Soltero,a",
           cohabitation: "Unión libre",
           parent: "Padres",
           couple: "Esposo o esposa",
           children: "Hijos",
           friend: "Amigos",
           reward: "Reconocimiento",
           punish: "Sanción",
           complianceIssues: "Motivo de regularización",
           businessIssues: "Motivo de operación",
           disciplinaryIssues: "Motivo de disciplina",
           oralWarning: "Retroalimentación",
           commitLetter: "Carta compromiso",
           warningLetter: "Acta administrativa",
           RFC: "RFC",
           personalInfo: "Perfil personal",
           identityInfo: "Información de indentidad",
           familyInfo: "Datos familiares",
           workInfo: "Perfil laboral",
           occupancyInfo: "Experiencia laboral",
           rewardInfo: "Registros de reconocimientos y sanciones",
           staffStatusInfo: "Estado de empleado",
           upload: "Subir",
           status: "Estado",
           leaveTime: "Fecha que terminó de laboral ",
           enterTime: "La fecha de ingreso",
           leaveReason: "Motivo de su separación",
         },
       };
